import React from 'react';
import { Tooltip } from '@material-ui/core';
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { facebookShareUrl, twitterShareUrl } from 'hub/helpers/post';

type Direction = 'row' | 'column';
interface Props {
  socialMediaUrl: string;
  title: string;
  direction: Direction;
}

const SocialButtons = ({ socialMediaUrl, title, direction }: Props) => {
  const { t } = useTranslation('hub');

  return (
    <SocialButtonList $direction={direction}>
      <li>
        <Tooltip title={t('post.shareOnFacebookTitle')} placement="top" arrow>
          <SocialButtonLink href={facebookShareUrl({ url: socialMediaUrl })}>
            <FacebookIcon htmlColor="white" fontSize="small" />
          </SocialButtonLink>
        </Tooltip>
      </li>
      <li>
        <Tooltip title={t('post.shareOnTwitterTitle')} placement="top" arrow>
          <SocialButtonLink
            href={twitterShareUrl({
              url: socialMediaUrl,
              text: title,
            })}
          >
            <TwitterIcon htmlColor="white" fontSize="small" />
          </SocialButtonLink>
        </Tooltip>
      </li>
    </SocialButtonList>
  );
};

const SocialButtonList = styled.ul<{ $direction: Direction }>`
  padding: 0;
  margin: 0;
  list-style: none;
  display: flex;
  gap: 12px;
  flex-direction: ${({ $direction }) => $direction || 'row'};

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: ${({ $direction }) => $direction || 'column'};
  }
`;

const SocialButtonLink = styled.a`
  display: flex;
  height: 29px;
  width: 29px;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.palette.secondary.light};
  border-radius: 500px;

  svg {
    height: 20px;
  }

  ${({ theme }) => theme.breakpoints.up('sm')} {
    height: 35px;
    width: 35px;

    svg {
      height: 25px;
    }
  }
`;

export default SocialButtons;
